import RouteResource from "./route.resource";

const routeModule = angular
  .module("app.resources.route", [])
  .service("Route", RouteResource);

export default routeModule;



// WEBPACK FOOTER //
// ./src/resources/route/route.module.js